export default class BookingRoomType {
    static init(): void {
        const filter = document.querySelector('.booking-filter');

        const containers = document.querySelectorAll('.booking-container') as NodeListOf<HTMLElement>;
        containers.forEach(container => {
            const items = filter?.querySelectorAll('.booking-filter__item') as NodeListOf<HTMLElement>;

            const showAll = container.querySelector('.show-all');

            showAll?.addEventListener('click', () => {
                showAllInType();
            });

            if (container.hasAttribute('data-filter-by-type')) {
                items?.forEach(item => {
                    item.addEventListener('click', () => {
                        filterRooms(item);
                        let type = item.getAttribute('data-room-type');
                        //showThreeRoomsInType(type);
                        //hideShowAllButton();
                    })
                });
            }

            //showThreeRoomsInType();
            //hideShowAllButton();


            function filterRooms(active: HTMLElement) {
                items?.forEach(item => {
                    item.classList.remove('booking-filter__item--active');
                });
                active.classList.add('booking-filter__item--active');

                const type = active.getAttribute('data-room-type');

                const rooms = container.querySelectorAll('.booking-room__grid .booking-room');
                rooms.forEach(room => {
                    room.classList.remove('d-none');
                    if (room.getAttribute('data-room-type') === type || type === 'all') {
                        room.classList.remove('d-none');
                    } else {
                        room.classList.add('d-none');
                    }
                });
            }

            function showThreeRoomsInType(type: string | null = 'all') {
                let rooms = container.querySelectorAll('.booking-room__grid .booking-room');
                if (type !== 'all') {
                    rooms = container.querySelectorAll(`.booking-room__grid .booking-room[data-room-type="${type}"], .booking-room__grid .booking-room:not([data-room-type])`);
                }

                rooms.forEach((room, index) => {
                    if (index > 2) {
                        room.classList.add('d-none');
                        showAll?.classList.remove('d-none');
                    }
                });
            }

            function showAllInType() {
                const type = filter?.querySelector('.booking-filter__item--active')?.getAttribute('data-room-type');

                let rooms = container.querySelectorAll('.booking-room__grid .booking-room');
                if ((type !== 'all')) {
                    rooms = container.querySelectorAll(`.booking-room__grid .booking-room[data-room-type="${type}"], .booking-room__grid .booking-room:not([data-room-type])`);
                }

                rooms.forEach(room => {
                    room.classList.remove('d-none');
                });

                showAll?.classList.add('d-none');
            }

            function hideShowAllButton() {
                let rooms = container.querySelectorAll('.booking-room__grid .booking-room');

                const type = filter?.querySelector('.booking-filter__item--active')?.getAttribute('data-room-type');
                if (filter && (!type || type !== 'all')) {
                    rooms = container.querySelectorAll(`.booking-room__grid .booking-room[data-room-type="${type}"], .booking-room__grid .booking-room:not([data-room-type])`);
                }

                if (rooms.length > 3) {
                    showAll?.classList.remove('d-none');
                } else {
                    showAll?.classList.add('d-none');
                }
            }

        });

    }
}
